<template>
  <div>
    <FilterOrganization :disable="true" @option="onOptionChange" :option="option"/>
    <ManagementAccountHistory  caption="Accounts" icon="cil-user" :item="accounts"  :option="option"/>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapGetters} from "vuex";
import ManagementAccountHistory from "@/projects/views/E-Performances/Management/Accounts/components/Historys";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";

export default {
  name: "Accounts",
  components: {FilterOrganization, ManagementAccountHistory},
  data: function () {
    return {
      accounts:[],
      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },
    }
  },

  mounted() {
  },

  created() {
    this.onInit();
  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad()
    },

    onLoad() {
      var data = {};
      data.organization = this.option.organization;
      (this.option.agency != 0)?data.agency = this.option.agency:null;

      this.$store.dispatch("member/config", data)
    },

    onOptionChange(e){
      this.isShow = false;
      this.option = e;
      // this.onLoad();
    },
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      objsMember : "member/members",
    })
  },

  watch: {
    objsMember: function (value) {
      this.accounts = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        try {
          objs.code = item.accounts.code
        }catch (e) {

        }
        objs.info = item.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value +" "+item.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value+" "+ item.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        // objs.affiliation = item.affiliation.title.filter(title => {
        //   if (title.key == lang) {
        //     return title
        //   }
        // })[0].value
        // objs.position = item.position.title.filter(title => {
        //   if (title.key == lang) {
        //     return title
        //   }
        // })[0].value
        objs.value = item;
        objs.historys = []

        items.push(objs)
      })
      this.accounts = items;

    },

    "option.organization"(value){
      console.log(value)
      this.onLoad()
    },

    "option.agency"(value){
      console.log(value)
      this.onLoad()
    },

  }
}
</script>

<style scoped>

</style>
